import script from "./BaseTemplateItemImageSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTemplateItemImageSetting.vue?vue&type=script&setup=true&lang=js"

import "./BaseTemplateItemImageSetting.vue?vue&type=style&index=0&id=159145fa&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-159145fa"]])

export default __exports__